module.exports = __webpack_public_path__ + "static/media/LiveStream.svg";